// @flow
import * as React from 'react';
import { PieChart as Chart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { displayPercent } from 'common/components/Number';
import PieChartTooltip from './PieChartTooltip';

const PADDING_BETWEEN_SECTORS = 5;

interface Data {
  name: string;
  color: string;
  value: number;
}

type Props = {
  data: Data[];
  height: number
}

function PieChart({ data, height }: Props) {
  return (
    <ResponsiveContainer height={height + (2 * PADDING_BETWEEN_SECTORS)} width="99%">
      <Chart>
        <Pie
          data={data}
          dataKey="value"
          endAngle={450}
          isAnimationActive
          startAngle={90}
        >
          {data.map(entry =>
            <Cell
              key={entry.name}
              fill={entry.color}
              strokeWidth={PADDING_BETWEEN_SECTORS}
            />,
          )}
        </Pie>
        <Tooltip content={<PieChartTooltip valueFormatter={displayPercent} />} />
      </Chart>
    </ResponsiveContainer>
  );
}

PieChart.defaultProps = {
  height: 150,
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/common/components/ui/charts/wrappers/PieChart.js